import { Standing } from "core/models/Bracket";

interface BracketStandingTableProps {
  standings: Standing[];
}

export default function BracketStandingTable({
  standings,
}: BracketStandingTableProps) {
  if (!standings || standings.length === 0) {
    return <div className="no-data">No standings available</div>;
  }

  return (
    <div className="bracket-table-wrapper">
      <div className="grid-row ">
        <span className="heading">Rank</span>
        <span className="heading">Participant</span>
        <span className="heading">Match W-L-T</span>
        <span className="heading">TB</span>
        <span className="heading">Set Wins</span>
        <span className="heading">Set Ties</span>
        <span className="heading">Points</span>
      </div>
      {standings.map((standing, index) => (
        <div className="grid-row bracket-head" key={index}>
          <span className="heading">{standing?.rank}</span>
          <span className="heading">{standing?.participant}</span>
          <span className="heading">
            {standing?.matches?.won}-{standing?.matches?.lost}-
            {standing?.matches?.tie}
          </span>
          <span className="heading">{standing?.tieBreaker}</span>
          <span className="heading">{standing?.setWon}</span>
          <span className="heading">{standing?.setTies}</span>
          <span className="heading">{standing?.points}</span>
        </div>
      ))}
    </div>
  );
}
